// extracted by mini-css-extract-plugin
export default {"CardBaseWithSash":"drag-overlay-card-module__CardBaseWithSash--Ps4n9"};